import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { DatePickerWithLabel } from 'commons/DatePicker/DatePickerWithLabel';
import { FileWithLabel } from 'commons/FileWithLabel/FileWithLabel';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { SimpleText } from 'commons/SimpleText/SimpleText';
import SkeletonLaboratoryGrid from 'components/Skeletons/SkeleronLaboratoryGrid/SkeletonLaboratoryGrid';
import React from 'react';
import { timestampToDate } from 'utils/processing/dates';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '50px 0'
  },
  countryAutoComplete: {
    minWidth: '300px',
    margin: 0,
    '& .MuiTextField-root': {
      marginTop: 0
    }
  },
  generalPadding: {
    paddingTop: theme.spacing(5)
  }
}));



export const ProductTestMachineInformation = ({ changedFields, productTestMachineInfo, onChange, isLoadingTestDetails }) => {
  const classes = useStyles();

  return (
    !isLoadingTestDetails ?
      <div className={classes.generalPadding}>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={6}>
            <Grid container direction='column' spacing={2}>
              <SimpleText
                label='customer'
                value={productTestMachineInfo?.customer}
              />
              <SimpleText
                label='type'
                value={productTestMachineInfo?.type}
              />
              <SimpleText
                label='name'
                value={productTestMachineInfo?.name}
              />
              <SimpleText
                label='serialNumber'
                value={productTestMachineInfo?.serialNumber}
              />
              <SimpleText
                label='participantLaboratory'
                value={productTestMachineInfo?.partLab ? localize('yes'): localize('no')}
              />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction='column' spacing={2}>
              <FileWithLabel
                file={productTestMachineInfo?.tdsFiles}
                label='technicalDataSheet'
              />
              <FileWithLabel
                file={productTestMachineInfo?.startingProcedureFile}
                label="startingProcedure"
              />
              <SimpleText
                label='scheduledDeliveryDate'
                value={timestampToDate(productTestMachineInfo?.scheduledDeliveryDate) || ''}
              />
              <DatePickerWithLabel
                enableColorChangeOnModification
                label='productReceptionDate'
                onChange={value => onChange(value, ['deliveryDate'])}
                startsModified={changedFields.includes('deliveryDate')}
                value={productTestMachineInfo?.deliveryDate}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      :
      <SkeletonLaboratoryGrid className={classes.container} />
  );

};